import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router";
import { UserService } from "../../../core/services/user.service";
import { AuthService } from "../../../core/services/auth.service";
import { PermissionService } from 'src/app/core/services/permisson.service';
import { MatDialog } from '@angular/material/dialog';
import { API_SPEC_URL,
  VDSP_AGN_ONBOARDING_GUIDE_URL,
  ADV_ONBOARDING_GUIDE_URL,
  VDSP_AGN_HELPER_GUIDE_URL,
  NON_API_ADV_ROLES,
  AGN_ROLES,
  PLATFORM_ROLES,
  VDSP_ADV_HELPER_GUIDE_URL,
  ROLES_WITH_BALANCE_ACCESS,
  VDSP_CREATIVE_MACROS_GUIDE_URL,
  ADSP_POLICIES_GUIDE_URL,
 } from 'src/app/models/common';
import { AppConfig } from 'src/app/configs/app.config';
import { PlatformNotificationService } from 'src/app/core/services/platform-notofication.service';

@Component({
  selector: 'dmp-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  // user: User;
  api_spec_url = API_SPEC_URL;

  vdsp_agn_onboarding_guide_url = VDSP_AGN_ONBOARDING_GUIDE_URL;

  vdsp_agn_helper_guide_url = VDSP_AGN_HELPER_GUIDE_URL;

  adv_onboarding_guide_url = ADV_ONBOARDING_GUIDE_URL;

  vdsp_adv_helper_guide_url = VDSP_ADV_HELPER_GUIDE_URL;

  vdsp_creative_macros_guide_url = VDSP_CREATIVE_MACROS_GUIDE_URL;

  adsp_policy_guide_url = ADSP_POLICIES_GUIDE_URL;

  ispfmRole: boolean = false;
  isNonAPIAdvRole: boolean = false;
  isAgnRole: boolean = false;
  readonly siteLogo: string;
  readonly showDocumentsAndAnalytic: boolean = true;

  constructor(private router: Router,
    private userService: UserService,
    private authService: AuthService,
    public dialog: MatDialog,
    public permissionService: PermissionService,
    private platformNotificationService: PlatformNotificationService
  ) {
    this.siteLogo = AppConfig.SITE_LOGO;
    this.showDocumentsAndAnalytic = !AppConfig.WHITE_LABEL_MODE;
  }

  public showDashboard = false;
  role: string;
  accountDetails: boolean = false;
  version;
  amount;
  balanceColor;
  showBalance: boolean = false;
  isBurnRateEnabled: boolean = false;
  currency;
  advertiser_id;
  agency_advertiser_id;
  agency_id;
  analyticsEnabled: boolean = false;
  apnx_enabled: boolean = false;
  adspEnabled: boolean = false;
  clientId;
  clientType: string;
  balanceTooltipMsg: string;
  notification: Object;

  ngOnInit() {
    this.role = localStorage.getItem("role");
    this.ispfmRole = PLATFORM_ROLES.has(this.role);
    this.isNonAPIAdvRole = NON_API_ADV_ROLES.has(this.role);
    this.isAgnRole = AGN_ROLES.has(this.role);
    if (this.role == 'agency_advertiser_reporting_user') {
      this.agency_advertiser_id = localStorage.getItem('agency_advertiser_id')
    }
    if (this.role != "agency_advertiser_reporting_user") {
      this.agency_id = localStorage.getItem("agency_id");
    }
    this.advertiser_id = localStorage.getItem("advertiser_id");
    this.getVersion();
    this.checkRole();
    this.apnx_enabled = localStorage.getItem("apnx_enabled") == "true";
    if (
      this.role == "agency_primary_admin" ||
      this.role == "advertiser_primary_admin"
    )
      this.getClientConfig();
    if (this.showBalance) this.getAccounts();
    this.getLatestNotification();
  }

  getClientConfig() {
    this.clientId = this.agency_id ? this.agency_id : this.advertiser_id;
    this.clientType = this.agency_id ? "agency" : "advertiser";
    this.permissionService.getConfig(this.clientId, this.clientType).subscribe(
      (res) => {
        this.analyticsEnabled = res.data.qlik_enabled;
      },
      (err) => {}
    );
  }

  getVersion() {
    this.userService
      .getViziblVersion()
      .subscribe((res) => (this.version = res.version));
    // return this.version;
  }

  checkRole() {
    if (ROLES_WITH_BALANCE_ACCESS.has(this.role)) this.showBalance = true;
  }

  vdspEnabledPlatformRole(type = "agency") {
    if (this.ispfmRole && this.role != "account_manager") {
      return true;
    } else if (this.role == "account_manager") {
      if (type == "agency" && localStorage.getItem("agn_with_apnx") == "true") {
        return true;
      }
      if (
        type == "advertiser" &&
        localStorage.getItem("adv_with_apnx") == "true"
      ) {
        return true;
      }
    }
    return false;
  }

  adspEnabledPlatformRole(type = 'agency') {
    if(this.ispfmRole && this.role != 'account_manager') {
      return true
    }
    else if(this.role == 'account_manager') {
      if(type == 'agency' && (localStorage.getItem('agn_with_adsp') == 'true')) {
        return true
      }
      if(type == 'advertiser' && (localStorage.getItem('adv_with_adsp') == 'true')) {
        return true
      }
    }
    return false;
  }

  getAccounts() {
    let client = {};
    client["name"] = this.agency_id ? "agency" : "advertiser";
    client["id"] = this.agency_id ? this.agency_id : this.advertiser_id;
    client["params"] = this.agency_id
      ? { agency_id: this.agency_id }
      : { advertiser_id: this.advertiser_id };
    this.permissionService.getAccounts(client).subscribe((res) => {
      this.isBurnRateEnabled = res.data.config.burn_rate_check;
      this.currency = res.data.currency;
      if (this.isBurnRateEnabled) {
        this.amount = res.data.account.projected_balance;
        this.balanceTooltipMsg = `As of ${
          res.data.latest_transaction_date
        }. The balance you see here includes a fully reconciled spends of  ${
          this.currency
        } ${res.data.account.balance.toFixed(
          2
        )} and additional projected/unreconciled spends of ${this.currency} ${(
          res.data.account.balance - res.data.account.projected_balance
        ).toFixed(
          2
        )}. So your actual reconciled account balance may be different and will be updated on a periodic basis.`;
      } else {
        this.amount = res.data.account.balance;
        this.balanceTooltipMsg = `As of ${res.data.latest_transaction_date}. The balance you see here is not fully reconciled for spends in your account that would have occurred after the timestamp you see here. So your actual account balance may be different and will be updated on a periodic basis.`;
      }
      this.balanceColor =
        this.amount > res.data.config.notification_amount ? "green" : "red";
    });
  }

  validateAccounts() {
    if (
      this.role != "platform_superadmin" &&
      this.role != "platform_admin" &&
      this.role != "account_manager"
    ) {
      if (this.permissionService.getViewPermissions("account_balance")) {
        return true;
      }
    }
    return false;
  }

  toggleDashBoard() {
    this.showDashboard = !this.showDashboard;
  }

  getUsername() {
    return localStorage.getItem("first_name") || "";
  }

  getLatestNotification() {
    let params = {};
    if (!PLATFORM_ROLES.has(this.role)) {
      if (this.role == "agency_advertiser_reporting_user") {
        params["agency_advertiser_id"] = this.agency_advertiser_id;
      } else if (this.agency_id) {
        params["agency_id"] = this.agency_id;
      } else if (this.advertiser_id) {
        params["advertiser_id"] = this.advertiser_id;
      }
    }
    this.platformNotificationService
      .retrieveLatestNotification(params)
      .subscribe((res) => {
        this.notification = res
      });
  }

  isObjectEmpty(): boolean {
    return this.notification && Object.keys(this.notification).length != 0;
  }

  logout() {
    this.dialog.closeAll();
    this.authService.logoutUser();
  }
}
